import { useQuery } from '@tanstack/react-query';
import fileDownload from 'js-file-download';
import { useContext } from 'react';
import AppContext from 'src/AppContext';
import { GetLicenseSystemUpdateInput, GetLicenseSystemUpdatePayload } from './generated/types';
import { decodeBase64 } from 'src/shared/base64Utils';

const query = `query GetLicenseSystemUpdate($input: GetLicenseSystemUpdateInput!) {
    getLicenseSystemUpdate(input: $input) {
        updateBinaryData
        updateNumber
    }
}`;


export const useDownloadLicenseUpdate = (licenseSystemId: string, orgId: string, trigger: boolean) => {
    const context = useContext(AppContext);

    return useQuery<boolean, Error>({
        queryKey: ['donwloadLicenseUpdate', licenseSystemId],

        queryFn: async () => {

            const input: GetLicenseSystemUpdateInput = { licenseSystemId, orgId: orgId! };

            const { data } = await (context.api.graphql({ query, variables: { input } }) as Promise<{
                data: {
                    getLicenseSystemUpdate: GetLicenseSystemUpdatePayload;
                };
            }>);

            const decodedContent = decodeBase64(data.getLicenseSystemUpdate.updateBinaryData!);
            const updateNumber = data.getLicenseSystemUpdate.updateNumber!;

            fileDownload(decodedContent, `${licenseSystemId}-${updateNumber}.lic`);

            return true;
        },
        enabled: trigger,
        staleTime: 0,
    });
};